"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("./enums");
const hid_1 = __importDefault(require("./modules/hid"));
const pid_1 = __importDefault(require("./modules/pid"));
const utils_1 = __importDefault(require("./utils"));
exports.defaultOption = {
    validationIdMode: enums_1.ValidtionIdType.RETURN_FALSE,
};
const mainDigit = {
    getDigit(id, digitType, option = exports.defaultOption) {
        const errorCheckIdIsNumber = utils_1.default.getErrorWithCheckIdIsNumber(id);
        if (errorCheckIdIsNumber) {
            return utils_1.default.handlerError(errorCheckIdIsNumber, option.validationIdMode);
        }
        const idNum = Number(id);
        const errorValidationId = utils_1.default.getErrorWithValidationId(idNum, digitType, -1);
        if (errorValidationId) {
            return utils_1.default.handlerError(errorValidationId, option.validationIdMode);
        }
        const idStr = utils_1.default.padToIdString(idNum, digitType, false);
        const digitResult = utils_1.default.calcDigit(idStr, digitType);
        return (Number(idNum) * 10) + digitResult;
    },
    checkDigit(id, digitType, option = exports.defaultOption) {
        const errorCheckIdIsNumber = utils_1.default.getErrorWithCheckIdIsNumber(id);
        if (errorCheckIdIsNumber) {
            return utils_1.default.handlerError(errorCheckIdIsNumber, option.validationIdMode);
        }
        const idNum = Number(id);
        const errorValidationId = utils_1.default.getErrorWithValidationId(idNum, digitType);
        if (errorValidationId) {
            return utils_1.default.handlerError(errorValidationId, option.validationIdMode);
        }
        const idStr = utils_1.default.padToIdString(idNum, digitType, true);
        const digitResult = utils_1.default.calcDigit(idStr, digitType);
        return (digitResult === Number(idStr[idStr.length - 1]));
    },
    formatId(id, digitType, formatType = enums_1.FormatType.AUTO, option = exports.defaultOption) {
        // tslint:disable-next-line:no-console
        console.warn('formatId is duplicated in @cdglib/js-moi-xid version 1.1.0. You can switch to getFormat function');
        return this.getFormat(id, digitType, formatType, option);
    },
    getFormat(id, digitType, formatType = enums_1.FormatType.AUTO, option = exports.defaultOption) {
        const errorCheckIdIsNumber = utils_1.default.getErrorWithCheckIdIsNumber(id);
        if (errorCheckIdIsNumber) {
            return utils_1.default.handlerError(errorCheckIdIsNumber, option.validationIdMode);
        }
        const idNum = Number(id);
        const errorValidationId = utils_1.default.getErrorWithValidationId(idNum, digitType);
        if (errorValidationId) {
            return utils_1.default.handlerError(errorValidationId, option.validationIdMode);
        }
        switch (digitType) {
            case enums_1.DigitType.PID:
                return pid_1.default.getFormat(idNum, digitType, formatType);
            case enums_1.DigitType.HID:
                return hid_1.default.getFormat(idNum, digitType, formatType);
            default:
                throw new Error('ประเภท digit ไม่ถูกต้อง');
        }
    },
    getDataType(id, digitType, option = exports.defaultOption) {
        const errorCheckIdIsNumber = utils_1.default.getErrorWithCheckIdIsNumber(id);
        if (errorCheckIdIsNumber) {
            return utils_1.default.handlerError(errorCheckIdIsNumber, option.validationIdMode);
        }
        const idNum = Number(id);
        const errorValidationId = utils_1.default.getErrorWithValidationId(idNum, digitType);
        if (errorValidationId) {
            return utils_1.default.handlerError(errorValidationId, option.validationIdMode);
        }
        switch (digitType) {
            case enums_1.DigitType.PID:
                return pid_1.default.getDataType(idNum, digitType);
            case enums_1.DigitType.HID:
                return hid_1.default.getDataType(idNum, digitType);
            default:
                throw new Error('ประเภท digit ไม่ถูกต้อง');
        }
    },
};
exports.default = mainDigit;
